/*
  The drops page's FAQ accordion: questions slide open and shut, and opening
  one closes any other open question.

  Works on native <details> items, only inside the drops page (.vi-drops),
  so the membership page's FAQ (the same shared block) is untouched. A
  click on the summary is taken over to animate the item's height between
  the summary alone and the summary with its content; without script the
  items still open and close natively. Reduced motion skips the animation.
*/
(() => {
  if (window.viDropAccordionInitialized) return;
  window.viDropAccordionInitialized = true;

  const DURATION = 320;
  const EASING = 'cubic-bezier(0.22, 0.61, 0.36, 1)';
  const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');

  // Each kind of accordion: its items, and the group that keeps one open.
  const GROUPS = [
    { item: '.vi-faq__item', group: '.vi-faq' },
  ];

  // The item's height with only its question showing: the question plus the
  // item's own borders.
  const closedHeight = (item) => {
    const style = getComputedStyle(item);
    const borders = parseFloat(style.borderTopWidth) + parseFloat(style.borderBottomWidth);
    return item.querySelector('summary').offsetHeight + borders;
  };

  const animate = (item, opening) => {
    if (item.viFaqAnimation) item.viFaqAnimation.cancel();

    if (reducedMotion.matches) {
      item.open = opening;
      return;
    }

    const from = item.offsetHeight;
    if (opening) item.open = true;
    const to = opening ? item.scrollHeight + (item.offsetHeight - item.clientHeight) : closedHeight(item);

    item.style.overflow = 'hidden';
    const animation = item.animate({ height: [`${from}px`, `${to}px`] }, { duration: DURATION, easing: EASING });
    item.viFaqAnimation = animation;

    const settle = () => {
      if (item.viFaqAnimation !== animation) return;
      item.viFaqAnimation = null;
      item.style.overflow = '';
      if (!opening) item.open = false;
    };
    animation.addEventListener('finish', settle);
    animation.addEventListener('cancel', settle);
  };

  document.addEventListener('click', (event) => {
    const summary = event.target.closest('.vi-drops details > summary');
    if (!summary) return;
    const item = summary.parentElement;
    const kind = GROUPS.find((entry) => item.matches(entry.item));
    if (!kind) return;

    event.preventDefault();
    // An item mid-close still reads as open; treat it as closing.
    const isOpen = item.open && !(item.viFaqAnimation && item.viFaqAnimation.playState === 'running' && item.viFaqClosing);

    if (isOpen) {
      item.viFaqClosing = true;
      animate(item, false);
      return;
    }

    item.viFaqClosing = false;
    const group = item.closest(kind.group);
    if (group) {
      group.querySelectorAll(`${kind.item}[open]`).forEach((other) => {
        if (other === item) return;
        other.viFaqClosing = true;
        animate(other, false);
      });
    }
    animate(item, true);
  });
})();
